import React from 'react'
import {Button, Form, Input, Layout, message, Select} from "antd";
import HeaderNav from "../header/header";
const { Content } = Layout;

const { TextArea } = Input;
const { Option } = Select;

class Support extends React.Component{
    formRef = React.createRef();
    onFinish=(values)=>{
        let Lowercase = this.formRef.current.getFieldValue('Lowercase')
        if(Lowercase==='lenovo'){

        }else{
            message.warn('Please input your Type In Lowercase: LENOVO!')
        }
    }
    render() {
        return <div>
            <HeaderNav parmas={'/lhp'}/>
            <Layout className="site-layout-background" style={{ padding: '24px 0',width: '1000px',margin: '0 auto'  }}>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <p style={{width:'70%',margin:'30px auto',fontWeight:'bold',lineHeight:'36px',background:'#deecf7',padding:'30px'}}>
                        To request a new Lenovo ID to login the new dispute portal, please visit LPH (Lenovo Partner Hub), from the below link to LPH registration:
                        <br/>
                        <a target={'_blank'} href="https://www.lenovopartnerhub.com/en-GB/web/lenovo-global-site/getting-started">
                            https://www.lenovopartnerhub.com/en-GB/web/lenovo-global-site/getting-started
                        </a>
                    </p>
                </Content>
            </Layout>
        </div>

    }
}

export default Support;